export const NAVER_MAP_TAROMANCE_URL = 'https://map.naver.com/p/search/%ED%83%80%EB%A1%9C%EB%A7%A8%EC%8A%A4';
export const INSTAGRAM_TAROMANCE_URL = 'https://www.instagram.com/taromance/';
